const ticket = {
  getlist: 'ticket/getlist',
  reply: 'ticket/reply-by-admin',
  update: 'ticket/update',
  remove: 'ticket/remove',
  get: 'ticket/get',
  getall: 'ticket/getall',
  clearcache: 'ticket/clear-cache',
}
export default ticket
